// extracted by mini-css-extract-plugin
export default {"addButton":"xAHaNtSe94dFvtfH59kK"};